const authentication = {
  loginMarketingHeadline: "The easiest way to manage your fleet",
  loginMarketingSubtitle:
    "Track your vehicles, maintenance, and drivers in one place. Save time and focus on growing your business.",
  // The login's marketing panel (LoginArtwork). Arabic is Figma's copy; this
  // is our translation until UI/UX provides one.
  loginArt: {
    eyebrow: "Live tracking",
    headline: "The easiest way,",
    headlineAccent: "to manage your assets.",
    lead: "Follow every trip moment by moment, and catch problems before they disrupt your operations.",
    liveTag: "Live · 42 assets reporting now",
    depot: "Jeddah city depot",
    alerts: {
      speeding: "Speeding · 96 km/h",
      idle: "Idle · 12 min",
    },
    tracked: {
      status: "Moving",
      unit: "km/h",
      arrival: "Arrival {{time}}",
    },
    stats: {
      onRoad: "On the road now",
      maintenance: "Maintenance due",
      onTime: "On-time delivery",
    },
  },
  // The OTP screen's marketing panel (OtpArtwork). Arabic is the design's
  // copy; this is our translation.
  otpArt: {
    eyebrow: "Secure verification",
    headline: "One code,",
    headlineAccent: "and your account is safe.",
    lead: "Enter the code sent to your email to finish signing in securely.",
    sentTitle: "Code sent",
    sentTo: "To your email",
    expiresIn: "Expires in",
    verified: "Verified successfully",
    stats: {
      encryption: "Full encryption",
      validity: "Code validity",
      attempts: "Attempts left",
    },
  },
  loginTitle: "Welcome back!",
  loginSubtitle: "Please enter your details to sign in",
  usernameLabel: "Username",
  usernamePlaceholder: "Username",
  passwordLabel: "Password",
  passwordPlaceholder: "Enter your password",
  showPassword: "Show password",
  hidePassword: "Hide password",
  forgotPasswordLink: "Forgot your password ?",
  signInButton: "Sign in",
  signingInButton: "Signing in...",
  sessionTimedOut:
    "Your session has timed out due to inactivity. Please log in again.",
  sessionTimeoutWarningTitle: "Session about to expire",
  sessionTimeoutWarningMessage:
    "You will be logged out automatically due to inactivity in",
  sessionTimeoutStayButton: "Stay signed in",
  invalidCredentials: "Invalid username or password. Please try again.",

  otpTitle: "Verify your code",
  otpSubtitle:
    "Enter the verification code you just received on {{destination}}.",
  otpDidNotReceive: "Didn't receive the code?",
  otpCodeLabel: "Verification Code",
  otpCodePlaceholder: "123456",
  verifyButton: "Verify Code",
  verifyingButton: "Verifying...",
  verifiedButton: "Verified successfully",
  resendOtpButton: "Resend Code",
  resendingOtpButton: "Resending code...",
  resendOtpCountdown: "Resend code in {{seconds}}s",
  resendOtpCountdownTime: "Resend code in {{time}}",
  otpResentSuccess: "Verification code resent successfully.",
  invalidOtp: "Invalid verification code. Please check and try again.",
  noOtpInProgress:
    "No verification is currently in progress. Please log in again.",

  forgotPasswordTitle: "Forgot Password?",
  forgotPasswordSubtitle:
    "Enter your registered email and we'll send you a verification code to reset your password.",
  emailLabel: "Email",
  emailPlaceholder: "name@company.com",
  sendResetCodeButton: "Send Code",
  sendingResetCodeButton: "Sending code...",
  sendResetCodeCountdown: "Try again in {{time}}",

  resetPasswordTitle: "Create New Password",
  resetPasswordSubtitle: "Please enter your new password below.",
  newPasswordLabel: "New Password",
  newPasswordPlaceholder: "Enter new password",
  confirmPasswordLabel: "Confirm Password",
  confirmPasswordPlaceholder: "Confirm new password",
  resetPasswordButton: "Reset Password",
  resettingPasswordButton: "Resetting password...",
  resetPasswordSuccessTitle: "Password Reset Successful",
  resetPasswordSuccessDescription:
    "Your password has been successfully updated. You can now log in with your new password.",

  passwordReqMinLength: "At least 8 characters",
  passwordReqUppercase: "One uppercase letter (A-Z)",
  passwordReqLowercase: "One lowercase letter (a-z)",
  passwordReqNumber: "At least one number",
  passwordReqSpecialChar: "One special character (@!#$%^&*)",

  activateAccountTitle: "Set Your Password",
  activateAccountSubtitle:
    "Set a password to complete your account activation.",
  activateAccountSubtitleWithEmail:
    "Create a password to activate the company administrator account for {{email}}.",
  activateAccountButton: "Activate Account",
  activatingAccountButton: "Activating account...",
  activateAccountSuccessTitle: "Account Activated",
  activateAccountSuccessDescription:
    "Your account has been activated successfully. You can now log in.",

  checkingLink: "Verifying link...",
  linkValidTitle: "Valid Link",
  linkValidDescription: "This link is valid and ready to proceed.",
  linkExpiredTitle: "Link Expired",
  linkExpiredDescription: "This link has expired. Please request a new one.",
  linkAlreadyUsedTitle: "Link Already Used",
  linkAlreadyUsedDescription:
    "This link has already been used. Please log in or request a new one.",
  linkSupersededTitle: "Link Replaced",
  linkSupersededDescription:
    "A newer activation link has been sent. Please use the most recent email.",
  linkInvalidTitle: "Invalid Link",
  linkInvalidDescription:
    "This link is invalid or malformed. Please check the URL or request a new link.",
  resendActivationLinkButton: "Resend Activation Link",
  resendingActivationLinkButton: "Resending activation link...",
  activationLinkResentSuccess:
    "A new activation link has been sent to your email.",

  backToLogin: "Back to Login",
  proceedToLogin: "Proceed to Login",
  continueButton: "Continue",
};

export default authentication;
